module.exports = ":host {\n  border-bottom: 1px solid rgba(58, 108, 201, 0.2);\n  padding: 0.9375em 1.875em;\n  width: 100%;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center; }\n\n.app-header-logo img {\n  max-height: 3.125em;\n  vertical-align: top; }\n\na {\n  color: #434c5c;\n  cursor: pointer; }\n  a:hover {\n    text-decoration: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./ng2/shared/app-header/app-header.component.scss
// module id = 1206
// module chunks = 0